define("Tavano.PageGenImgNoscriptFix.PageGenImgNoscriptFix", [
  "Backbone.View",
  "underscore",
  "Backbone.View.Plugin.PageGeneratorImages",
], function (BackboneView, _, _CorePageGeneratorImagesPlugin) {
  "use strict";
  /* global SC, require */
  function backboneViewPageGeneratorImages(tmpl_str) {
    if (SC.isPageGenerator()) {
      return tmpl_str.replace(
        /(<img\s+[^>]*>\s*<\/img>|<img\s+[^>]*\/>|(?:<img\s+[^>]*>)(?!\s*<\/img>))(?!\s*<\s*\/noscript\s*>)/gim,
        "<noscript>$1</noscript>",
      );
    }
    return tmpl_str;
  }
  function installPageGeneratorNoscriptOverride() {
    BackboneView.postCompile.uninstall("pageGeneratorWrapImagesNoscript");
    BackboneView.postCompile.install({
      name: "pageGeneratorWrapImagesNoscript",
      priority: 40,
      execute: backboneViewPageGeneratorImages,
    });
  }
  /**
   * Mirrors Commons/Core View.compileTemplate but uses backboneViewPageGeneratorImages
   * from this extension (Core View calls the core helper directly, bypassing postCompile).
   * Loaded asynchronously so missing modules do not break the extension on older stacks.
   */
  function patchViewCompileTemplate() {
    require([
      "View",
      "Utils",
      "Backbone.View.DebugTemplateName",
      "SC.BaseComponent.Plugin.RecollectCMSSelectors",
      "SC.BaseComponent.Plugin.PostRender",
    ], function (ViewMod, UtilsMod, debugMod, recMod, postMod) {
      var ViewClass =
        ViewMod && (ViewMod.View !== undefined ? ViewMod.View : ViewMod);
      var backboneViewDebugTemplateName =
        (debugMod && debugMod.backboneViewDebugTemplateName) || debugMod;
      var scBaseComponentPluginRecollectCMSSelectorsGenerator =
        (recMod &&
          recMod.scBaseComponentPluginRecollectCMSSelectorsGenerator) ||
        recMod;
      var scBaseComponentPluginPostRender =
        (postMod && postMod.scBaseComponentPluginPostRender) || postMod;
      if (
        !ViewClass ||
        !ViewClass.prototype ||
        typeof ViewClass.prototype.compileTemplate !== "function" ||
        typeof UtilsMod.requireModules !== "function" ||
        typeof backboneViewDebugTemplateName !== "function" ||
        typeof scBaseComponentPluginRecollectCMSSelectorsGenerator !==
          "function" ||
        typeof scBaseComponentPluginPostRender !== "function"
      ) {
        return;
      }
      ViewClass.prototype.compileTemplate =
        function compileTemplatePageGenImgNoscriptFix() {
          var view = this;
          if (view.template && typeof view.template !== "function") {
            view.template = UtilsMod.requireModules(String(view.template));
          }
          if (typeof view.template === "function") {
            var templateContext = view.getTemplateContext();
            var templateString = view.template(templateContext);
            templateString = backboneViewDebugTemplateName(
              templateString,
              view,
            );
            templateString = backboneViewPageGeneratorImages(templateString);
            templateString =
              scBaseComponentPluginRecollectCMSSelectorsGenerator(
                templateString,
                view,
              );
            templateString = scBaseComponentPluginPostRender(
              templateString,
              view,
            );
            return templateString;
          }
          throw new Error("View template is not a function");
        };
    }, function () {
      /* Core View stack or dependencies not in this build — postCompile path only */
    });
  }
  function installAll() {
    installPageGeneratorNoscriptOverride();
    patchViewCompileTemplate();
  }
  return {
    mountToApp: function mountToApp(container) {
      _.defer(installAll);
    },
  };
});
